import { EstateCategoryDto, EstateTypeDto, OfferStatusDto } from 'common/enums/enums';

export type OffersItemDto = {
  id: string;
  unitNumber: string;
  status: OfferStatusDto;
  proposedRent: number;
  price: number;
  adultOccupants: number;
  childrenOccupants: number;
  appliedAt: Date;
  description: string;
  moveInDate: Date;
  estateId: string;
  unitId: string;
  estateStatus: string;
  location: string;
  city: string;
  type: string;
  category: EstateCategoryDto;
  beds: number;
  bathrooms: number;
  propertyArea: number;
  thumbnailUrl: string;
  renterId: string;
  renterName: string;
  renterThumbnailUrl: any;
  renterDateOfBirth: Date;
  renterAge: number;
  renterEmail: string;
  renterPhoneNumber: string;
  estateType: EstateTypeDto;
  ssn?: string;
  unitAvailableOn: string;
  rejectReason: string;
  isRunScreeningHandled: boolean;
  screeningConsents: ScreeningConsent[];
  screeningCheckStatus: ScreeningCheckStatus;
  landlordId: string;
  isAllRunScreeningAccepted: boolean;
};

export type ScreeningConsent = {
  orderPlanId: string;
  title: string;
  price: number;
  screeningCheckStatus: ScreeningCheckStatus;
  isRunScreeningAccepted: boolean | null;
  isPaymentConfirmed: boolean;
}

export enum ScreeningCheckStatus {
  NotRequested = 0,
  RequestedRenter = 1,
  RequestedLandlord = 2,
  Completed = 3
}

export type OfferItemDto = {
  id: string;
  status: string;
  proposedRent: number;
  price: number;
  thumbnailUrl: string;
  appliedAt: Date;
  moveInDate: Date;
  location: string;
  estateId: string;
  leaseDocumentName: string;
  leaseDocumentUrl: string;
  deposit: number;
  commission: number;
  state: string;
  city: string;
  category: EstateCategoryDto;
  beds: number;
  bathrooms: number;
  propertyArea: number;
  estateType: EstateTypeDto;
};
